<script setup lang="ts">
import { TypographyItem, TypographyWithPrefix } from '@/components/Typography'
import ShowableTypography from '@/components/Typography/ShowableTypography.vue'
import store from '@/store'
import { EDeviceActions } from '@/store/deviceStore/DeviceStoreTypes'
import { EStoreModules } from '@/store/storeType'
import moment from 'moment'
import { ref, watch } from 'vue'
import { useI18n } from 'vue-i18n'
import { DATETIME_FORMAT } from '../../../../utils/dateUtils'

const { t } = useI18n()

type Props = {
    deviceId?: number
}
const props = defineProps<Props>()

const apiKeyDeviceId = ref<number | undefined>()
const apiKey = ref<string | undefined>()
const ratelimit = ref<number>()

const getDeviceApiKey = (deviceId: number) =>
    store
        .dispatch(`${EStoreModules.DEVICE}/${EDeviceActions.GET_DEVICE_API_KEY}`, deviceId)
        .then(res => (apiKey.value = res.api_key))
        .catch(err => {
            ratelimit.value = err?.header?.rateLimit
            apiKeyDeviceId.value = undefined
            apiKey.value = undefined
            setTimeout(
                () => (ratelimit.value = undefined),
                (err?.header?.rateLimit - moment().unix()) * 1000
            )
        })

const handleShowApiKey = (value: boolean) => {
    if (!value || !props.deviceId || props.deviceId === apiKeyDeviceId.value) return
    apiKeyDeviceId.value = props.deviceId
    getDeviceApiKey(props.deviceId)
}

watch(
    () => props.deviceId,
    (newId, oldId) => {
        if (newId !== oldId) {
            showableRef.value?.resetShowable()
            apiKeyDeviceId.value = undefined
            apiKey.value = undefined
        }
    }
)

const showableRef = ref<{ resetShowable: () => void }>()
</script>

<template>
    <TypographyWithPrefix :prefix="$t('device.model.apiKey')" class="full-width">
        <template #edit>
            <TypographyItem
                v-if="ratelimit"
                class="has-text-danger"
                :label="
                    t('error.tooManyAttempts', {
                        timestamp: moment.unix(ratelimit).format(DATETIME_FORMAT)
                    })
                " />
            <ShowableTypography
                v-else
                ref="showableRef"
                :label="apiKey"
                class="flex align-items-center"
                @click="handleShowApiKey" />
        </template>
    </TypographyWithPrefix>
</template>
